/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import PageLayout from 'src/common/components/PageLayout';
import AddTopicModal from './AddTopicModal';
import { startLog } from 'src/api/modules/bitacora';
import { columnsTopics, action_buttons } from './utils/list_data';
import { useParams } from 'react-router-dom';
import { topicAPI } from 'src/api/modules/topic';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { inclusionThemesAPI } from 'src/api/modules/inclusionThemes';
import TableStart from './Component/TableStart';
import notice from 'src/common/components/Notice';
import { Grid, makeStyles } from '@material-ui/core';
import CustomButton from 'src/common/components/CustomButton';
export const rechazarArchivo = (archivo, resolucion, id_organo) => {};
export const enviarNotificacionResponsable = async (id_entidad, rol) => {
	rol = rol.toUpperCase();
	let estatus = rol === 'ENLACE' ? 'EP' : 'AT';
	estatus = rol === 'RESPONSABLE DE SEGUIMIENTO' ? 'APO' : estatus;
	topicAPI.enviarNotificacionResponsable(id_entidad, estatus).then((response) => {
		notice('Notificación Enviada', 'success');
	});
};

export const enviarNotificacionResponsableTemas = async (id_entidad, rol, user) => {
	rol = rol.toUpperCase();
	let estatus = rol === 'ENLACE' ? 'EP' : 'AC';
	estatus = rol === 'RESPONSABLE DE SEGUIMIENTO' ? 'APO' : estatus;
	inclusionThemesAPI
		.enviarNotificacionResponsable(id_entidad, estatus, user)
		.then((response) => {
			notice('Notificación Enviada', 'success');
		});
};

const useStyles = makeStyles({
	tableTHRepace: {
		fontWeight: 600,
		color: '#B5B5C3 !important',
		fontSize: '0.9rem',
		textTransform: 'none !important',
		letterSpacing: '0.1rem',
	},
	containerButtons: {
		marginTop: 20,
		width: '100%',
		margin: 0,
	},
	subContainerButtons: {
		flexDirection: 'row',
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'flex-end',
	},
	root: {
		marginTop: 20,
		width: '100%',
		margin: 0,
	},
});
const AddDocuments = () => {
	const { user } = useSelector((state) => state.auth);
	const systemLevelRole = user?.organos[0].nombrePerfil.toUpperCase();
	const classes = useStyles();
	const { id } = useParams();
	const [topic, setTopic] = useState([]);
	const [sesion, setSesion] = useState('');
	const [addTopicModal, setAddTopicModal] = useState(false);
	const history = useHistory();

	const openModal = () => {
		setAddTopicModal(true);
	};
	const getIsDisabledResponsable = (oficio, tarjeta, presentacion) => {
		let isdabled = true;

		if (
			typeof oficio != 'undefined' &&
			typeof tarjeta == 'undefined' &&
			typeof presentacion == 'undefined' &&
			(oficio?.validaSeguimiento === 'APO' || oficio?.validaSeguimiento === 'A')
		)
			isdabled = false;

		if (
			typeof oficio != 'undefined' &&
			typeof tarjeta != 'undefined' &&
			typeof presentacion != 'undefined'
		) {
			if (
				(oficio.validaSeguimiento === 'APO' &&
					tarjeta.validaSeguimiento === 'APO' &&
					presentacion.validaSeguimiento === 'APO') ||
				(oficio.validaSeguimiento === 'A' &&
					tarjeta.validaSeguimiento === 'A' &&
					presentacion.validaSeguimiento === 'A')
			)
				return false;
		}
		return isdabled;
	};
	const builddatosminos = (archivos, idEntidad, tipo) => {
		archivos.reverse();

		const oficio = archivos.find((x) => x.tipo === 'O');
		const tarjeta = archivos.find((x) => x.tipo === 'T');
		const presentacion = archivos.find((x) => x.tipo === 'P');
		const adicional = archivos.find((x) => x.tipo === 'A');
		let isSendDisabled = oficio === undefined;

		if (!isSendDisabled) {
			isSendDisabled =
				typeof tarjeta != 'undefined' || typeof presentacion != 'undefined'
					? true
					: false;
			if (isSendDisabled)
				isSendDisabled =
					typeof tarjeta != 'undefined' && typeof presentacion != 'undefined'
						? false
						: true;
		}

		if (systemLevelRole !== 'ENLACE') {
			isSendDisabled = getIsDisabledResponsable(oficio, tarjeta, presentacion);
		}

		const datosMinos = [
			{
				id: oficio ? oficio.id : '',
				idEntidad: idEntidad,
				tipo: 'O',
				entidad: tipo === 'Tema' ? 'TEMAINCLUIDO' : 'RESOLUCIONES',
				estatus: oficio ? oficio.validaSeguimiento : '',
				isSendDisabled: isSendDisabled,
				ruta:
					tipo === 'Tema'
						? 'temas/' + idEntidad + '/'
						: 'resoluciones/' + idEntidad + '/',
				title: 'Oficio',
				nombre: oficio ? oficio.nombre : '',
				message: oficio
					? oficio.rechazos?.length > 0
						? 'Motivo de Rechazo: ' + oficio.rechazos[0].mensaje
						: ''
					: '',
			},
			{
				id: tarjeta ? tarjeta.id : '',
				estatus: tarjeta ? tarjeta.validaSeguimiento : '',
				idEntidad: idEntidad,
				isSendDisabled: isSendDisabled,
				tipo: 'T',
				entidad: tipo === 'Tema' ? 'TEMAINCLUIDO' : 'RESOLUCIONES',
				ruta:
					tipo === 'Tema'
						? 'temas/' + idEntidad + '/'
						: 'resoluciones/' + idEntidad + '/',
				title: 'Tarjeta',
				nombre: tarjeta ? tarjeta.nombre : '',
				message: tarjeta
					? tarjeta.rechazos?.length > 0
						? 'Motivo de Rechazo: ' + tarjeta.rechazos[0].mensaje
						: ''
					: '',
			},
			{
				id: presentacion ? presentacion.id : '',
				estatus: presentacion ? presentacion.validaSeguimiento : '',
				idEntidad: idEntidad,
				isSendDisabled: isSendDisabled,
				tipo: 'P',
				entidad: tipo === 'Tema' ? 'TEMAINCLUIDO' : 'RESOLUCIONES',
				ruta:
					tipo === 'Tema'
						? 'temas/' + idEntidad + '/'
						: 'resoluciones/' + idEntidad + '/',
				title: 'Presentación',
				nombre: presentacion ? presentacion.nombre : '',
				message: presentacion
					? presentacion.rechazos?.length > 0
						? 'Motivo de Rechazo: ' + presentacion.rechazos[0].mensaje
						: ''
					: '',
			},
			{
				id: adicional ? adicional.id : '',
				idMigrado: adicional?.idEntidad,
				isMigrated: adicional?.migrado,
				versionArchivo: adicional?.versionArchivo,
				estatus: adicional ? adicional.validaSeguimiento : '',
				idEntidad: idEntidad,
				isSendDisabled: isSendDisabled,
				tipo: 'A',
				entidad: tipo === 'Tema' ? 'TEMAINCLUIDO' : 'RESOLUCIONES',
				ruta:
					tipo === 'Tema'
						? 'temas/' + idEntidad + '/'
						: 'resoluciones/' + idEntidad + '/',
				title: 'Adicionales',
				nombre: adicional ? adicional.nombre : '',
				message: adicional
					? adicional.rechazos?.length > 0
						? 'Motivo de Rechazo: ' + adicional.rechazos[0].mensaje
						: ''
					: '',
			},
		];
		return datosMinos;
	};
	const getResolucionesPorSesionEnlace = async () => {
		let data = [];
		try {
			await topicAPI.getByOrganSessionEnlace(id).then((response) => {
				if (response.temas.length === 0) {
					history.push(`/seguimiento/inicio/`);
					notice('No hay resoluciones para esta sesión', 'info');
				} else {
					response.temas.forEach((element) => {
						element['totalIcons'] = 4;
						element['perfil'] = systemLevelRole;
						element['userName'] =
							user.nombre +
							' ' +
							user.apellidoPaterno +
							' ' +
							user.apellidoMaterno;

						element['dataMinos'] = builddatosminos(
							element.archivos,
							element.id,
							'Resolucion'
						);
						element['tipo'] = 'Resolucion';
					});
					setSesion(
						response.temas.length > 0 ? response.temas[0].numeroSesion : ''
					);
					startLog(
						'Visualizo Resoluciones/Recomendaciones/Temas de ' +
							response?.temas[0]?.numeroSesion
					);
					data = response.temas;
				}
			});
		} catch (err) {
			notice(
				'Ha ocurrido un error con la petición contacte al administrador.',
				'error'
			);
			history.push('/');
		}

		let estatus = 'EP,AC,APO';
		if (systemLevelRole === 'ENLACE') {
			estatus = 'EP,AC,APO,VE';
		}
		inclusionThemesAPI
			.getThemesBySessionStatus(id, estatus)
			.then((response) => {
				if (response.length === 0) {
					setTopic((prev) => prev.concat(data));
					//notice('No hay resoluciones para esta sesión', 'info');
				} else {
					response.forEach((element) => {
						element['totalIcons'] = 4;
						element['perfil'] = systemLevelRole;
						element['userName'] =
							user.nombre +
							' ' +
							user.apellidoPaterno +
							' ' +
							user.apellidoMaterno;

						element['dataMinos'] = builddatosminos(
							element.archivos.length > 0 ? element.archivos : [],
							element.id !== null ? element.id : '',
							'Tema'
						);

						element['tipo'] = 'Tema';

						if (element.instituciones.length > 0) {
							element.instituciones.forEach((ri) => {
								let institutionsName = [
									...new Set(
										element.instituciones.map(
											(item) => `${item.institucion.nombre}, `
										)
									),
								];
								element['comite'] = institutionsName;
							});
						}
					});
					response.forEach((item) => {
						data.push({
							...item,
							fundamentoJuridico: item.fundamentoLegal,
							numeroResolucion: item.nombreTema,
						});
					});

					setTopic((prev) => prev.concat(data));
				}
			})
			.catch(() => notice('Ocurrio un error', 'error'));
	};

	const onEye = (id, tipo) => {
		if (tipo === 'Tema') {
			window.open(`/saoc-module-web/seguimiento/inclusion-temas/${id}`);
		} else window.open(`/saoc-module-web/seguimiento/resolucion/${id}`);
	};

	const onSuccess = (msg, type_msg, element) => {
		notice(msg, type_msg);
		setTopic([]);
		getResolucionesPorSesionEnlace();
	};
	const UpdateItemsRETe = (itemsData) => {
		setTopic([]);
		getResolucionesPorSesionEnlace();
	};
	const onClickSend = async (id, role, user, type) => {
		if (type === 'Tema') await enviarNotificacionResponsableTemas(id, role, user);
		else await enviarNotificacionResponsable(id, role);
		setTopic([]);
	};
	useEffect(() => {
		if (topic.length === 0) getResolucionesPorSesionEnlace();
	}, [topic, setTopic]);

	return (
		<PageLayout title={'Resoluciones/Recomendaciones de ' + sesion}>
			{topic.length > 0 ? (
				<TableStart
					UpdateItemsRETe={UpdateItemsRETe}
					columns={columnsTopics(onEye)}
					onclickDetalle={onEye}
					onClickEnviar={onClickSend}
					className={classes.tableTHRepace}
					items={topic}
					nameSesion={sesion}
				/>
			) : (
				<></>
			)}
			{systemLevelRole === 'ENLACE' ||
			systemLevelRole === 'ADMINISTRADOR GENERAL' ? (
				<Grid className={classes.containerButtons} container spacing={2}>
					<Grid className={classes.subContainerButtons} item md={12}>
						{action_buttons(openModal).map((button) => (
							<CustomButton
								key={button.title}
								mainText={button.title}
								color={button.color}
								onClick={button.onClick}
								disabled={button.disabled}
								className={button.className}
							/>
						))}
					</Grid>
				</Grid>
			) : (
				''
			)}
			<div className="d-none">
				<AddTopicModal
					open={addTopicModal}
					setOpen={setAddTopicModal}
					onConfirm={openModal}
					add={true}
					session={id}
					onSuccess={onSuccess}
				/>
			</div>
		</PageLayout>
	);
};

export default AddDocuments;
